module.exports = __webpack_public_path__ + "img/banner-3.90226754.jpg";